export default "__VITE_ASSET__69c7b54a__"